import PropTypes from "prop-types";
import StyleCount from "../StyleCount";
import LoadPreviousButton from "../LoadPrevious";
import RankingDisclaimer from "../RankingDisclaimer";
import FilterAndSort from "../../components/FilterAndSort";
import SelectedFacets from "../../components/SelectedFacets";
import styles from "./ResultsHeader.css";

const ResultsHeader = ({ showLoadPrevious, itemCount }) =>
  showLoadPrevious ? (
    <>
      <span className={styles.filterRow}>
        <FilterAndSort />
        <SelectedFacets />
        <StyleCount itemCount={itemCount} />
      </span>
      <LoadPreviousButton />
      <RankingDisclaimer />
    </>
  ) : (
    <>
      <span className={styles.filterRow}>
        <FilterAndSort />
        <SelectedFacets />
        <StyleCount itemCount={itemCount} />
      </span>
      <RankingDisclaimer />
    </>
  );

ResultsHeader.propTypes = {
  itemCount: PropTypes.number.isRequired,
  showLoadPrevious: PropTypes.bool.isRequired
};
export default ResultsHeader;
